// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BlueprintCounterRouteImport } from './routes/blueprint-counter'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as EstimatorRouteImport } from './routes/estimator'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as HomeTheaterInstallationNearMeRouteImport } from './routes/home-theater-installation-near-me'
import { Route as HomeTheaterNearMeRouteImport } from './routes/home-theater-near-me'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as SoldHomesRouteImport } from './routes/sold-homes'
import { Route as SupportRouteImport } from './routes/support'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as WholeHomeAudioInstallationNearMeRouteImport } from './routes/whole-home-audio-installation-near-me'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlogCustomHomeTheaterDesignGuideRouteImport } from './routes/blog.custom-home-theater-design-guide'
import { Route as CastlePinesHomeTheaterInstallationRouteImport } from './routes/castle-pines.home-theater-installation'
import { Route as CastlePinesSmartHomeInstallationRouteImport } from './routes/castle-pines.smart-home-installation'
import { Route as CastleRockHomeTheaterInstallationRouteImport } from './routes/castle-rock.home-theater-installation'
import { Route as CastleRockSmartHomeInstallationRouteImport } from './routes/castle-rock.smart-home-installation'
import { Route as CherryCreekHomeTheaterInstallationRouteImport } from './routes/cherry-creek.home-theater-installation'
import { Route as CherryCreekSmartHomeInstallationRouteImport } from './routes/cherry-creek.smart-home-installation'
import { Route as DenverSmartHomeInstallationRouteImport } from './routes/denver.smart-home-installation'
import { Route as EstimatorSavedRouteImport } from './routes/estimator_.saved'
import { Route as HighlandsRanchHomeTheaterInstallationRouteImport } from './routes/highlands-ranch.home-theater-installation'
import { Route as HighlandsRanchSmartHomeInstallationRouteImport } from './routes/highlands-ranch.smart-home-installation'
import { Route as ServiceAreasIndexRouteImport } from './routes/service-areas.index'
import { Route as ServiceAreasSlugRouteImport } from './routes/service-areas.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAvInstallationRouteImport } from './routes/services.av-installation'
import { Route as ServicesClimateControlRouteImport } from './routes/services.climate-control'
import { Route as ServicesCommercialAvRouteImport } from './routes/services.commercial-av'
import { Route as ServicesConferenceRouteImport } from './routes/services.conference'
import { Route as ServicesControl4RouteImport } from './routes/services.control4'
import { Route as ServicesDolbyAtmosHomeTheaterRouteImport } from './routes/services.dolby-atmos-home-theater'
import { Route as ServicesHiddenAudioRouteImport } from './routes/services.hidden-audio'
import { Route as ServicesHomeTheaterRouteImport } from './routes/services.home-theater'
import { Route as ServicesLightingRouteImport } from './routes/services.lighting'
import { Route as ServicesNetworkingRouteImport } from './routes/services.networking'
import { Route as ServicesOutdoorRouteImport } from './routes/services.outdoor'
import { Route as ServicesPrewireRouteImport } from './routes/services.prewire'
import { Route as ServicesRetrofitRouteImport } from './routes/services.retrofit'
import { Route as ServicesSecurityRouteImport } from './routes/services.security'
import { Route as ServicesShadingRouteImport } from './routes/services.shading'
import { Route as ServicesSmartHomeRouteImport } from './routes/services.smart-home'
import { Route as ServicesTvMountingRouteImport } from './routes/services.tv-mounting'
import { Route as ServicesVoiceControlRouteImport } from './routes/services.voice-control'
import { Route as ServicesWholeHomeAudioRouteImport } from './routes/services.whole-home-audio'
import { Route as ServicesWholeHomeVideoRouteImport } from './routes/services.whole-home-video'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsBankStatementsRouteImport } from './routes/tools.bank-statements'
import { Route as ToolsBeforeAfterRouteImport } from './routes/tools.before-after'
import { Route as ToolsBrandsRouteImport } from './routes/tools.brands'
import { Route as ToolsBusinessCardsRouteImport } from './routes/tools.business-cards'
import { Route as ToolsCableEstimatorRouteImport } from './routes/tools.cable-estimator'
import { Route as ToolsChangeOrdersRouteImport } from './routes/tools.change-orders'
import { Route as ToolsChecklistsRouteImport } from './routes/tools.checklists'
import { Route as ToolsClientsRouteImport } from './routes/tools.clients'
import { Route as ToolsContactsRouteImport } from './routes/tools.contacts'
import { Route as ToolsEngineeringRouteImport } from './routes/tools.engineering'
import { Route as ToolsEstimatesRouteImport } from './routes/tools.estimates'
import { Route as ToolsExpensesRouteImport } from './routes/tools.expenses'
import { Route as ToolsFollowUpsRouteImport } from './routes/tools.follow-ups'
import { Route as ToolsGalleryRouteImport } from './routes/tools.gallery'
import { Route as ToolsLetterRouteImport } from './routes/tools.letter'
import { Route as ToolsLoginRouteImport } from './routes/tools.login'
import { Route as ToolsMaintenanceRouteImport } from './routes/tools.maintenance'
import { Route as ToolsMarketingCopyRouteImport } from './routes/tools.marketing-copy'
import { Route as ToolsPhotosRouteImport } from './routes/tools.photos'
import { Route as ToolsProductsRouteImport } from './routes/tools.products'
import { Route as ToolsProjectsRouteImport } from './routes/tools.projects'
import { Route as ToolsProposalsRouteImport } from './routes/tools.proposals'
import { Route as ToolsRackLayoutRouteImport } from './routes/tools.rack-layout'
import { Route as ToolsReferralsRouteImport } from './routes/tools.referrals'
import { Route as ToolsReviewsRouteImport } from './routes/tools.reviews'
import { Route as ToolsSearchesRouteImport } from './routes/tools.searches'
import { Route as ToolsServiceTicketsRouteImport } from './routes/tools.service-tickets'
import { Route as ToolsSiteSurveysRouteImport } from './routes/tools.site-surveys'
import { Route as ToolsTestimonialsRouteImport } from './routes/tools.testimonials'
import { Route as ToolsTimesheetsRouteImport } from './routes/tools.timesheets'
import { Route as ToolsWarrantyRouteImport } from './routes/tools.warranty'
import { Route as EstimatorBlueprintIdRouteImport } from './routes/estimator_.blueprint.$id'
import { Route as ToolsBlogIndexRouteImport } from './routes/tools.blog.index'
import { Route as ToolsBlogIdRouteImport } from './routes/tools.blog.$id'
import { Route as ToolsBlogNewRouteImport } from './routes/tools.blog.new'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BlueprintCounterRoute = BlueprintCounterRouteImport.update({
            id: '/blueprint-counter',path: '/blueprint-counter',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const EstimatorRoute = EstimatorRouteImport.update({
            id: '/estimator',path: '/estimator',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const HomeTheaterInstallationNearMeRoute = HomeTheaterInstallationNearMeRouteImport.update({
            id: '/home-theater-installation-near-me',path: '/home-theater-installation-near-me',getParentRoute: () => rootRouteImport
          })
const HomeTheaterNearMeRoute = HomeTheaterNearMeRouteImport.update({
            id: '/home-theater-near-me',path: '/home-theater-near-me',getParentRoute: () => rootRouteImport
          })
const InventoryRoute = InventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const SoldHomesRoute = SoldHomesRouteImport.update({
            id: '/sold-homes',path: '/sold-homes',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const WholeHomeAudioInstallationNearMeRoute = WholeHomeAudioInstallationNearMeRouteImport.update({
            id: '/whole-home-audio-installation-near-me',path: '/whole-home-audio-installation-near-me',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogCustomHomeTheaterDesignGuideRoute = BlogCustomHomeTheaterDesignGuideRouteImport.update({
            id: '/blog/custom-home-theater-design-guide',path: '/blog/custom-home-theater-design-guide',getParentRoute: () => rootRouteImport
          })
const CastlePinesHomeTheaterInstallationRoute = CastlePinesHomeTheaterInstallationRouteImport.update({
            id: '/castle-pines/home-theater-installation',path: '/castle-pines/home-theater-installation',getParentRoute: () => rootRouteImport
          })
const CastlePinesSmartHomeInstallationRoute = CastlePinesSmartHomeInstallationRouteImport.update({
            id: '/castle-pines/smart-home-installation',path: '/castle-pines/smart-home-installation',getParentRoute: () => rootRouteImport
          })
const CastleRockHomeTheaterInstallationRoute = CastleRockHomeTheaterInstallationRouteImport.update({
            id: '/castle-rock/home-theater-installation',path: '/castle-rock/home-theater-installation',getParentRoute: () => rootRouteImport
          })
const CastleRockSmartHomeInstallationRoute = CastleRockSmartHomeInstallationRouteImport.update({
            id: '/castle-rock/smart-home-installation',path: '/castle-rock/smart-home-installation',getParentRoute: () => rootRouteImport
          })
const CherryCreekHomeTheaterInstallationRoute = CherryCreekHomeTheaterInstallationRouteImport.update({
            id: '/cherry-creek/home-theater-installation',path: '/cherry-creek/home-theater-installation',getParentRoute: () => rootRouteImport
          })
const CherryCreekSmartHomeInstallationRoute = CherryCreekSmartHomeInstallationRouteImport.update({
            id: '/cherry-creek/smart-home-installation',path: '/cherry-creek/smart-home-installation',getParentRoute: () => rootRouteImport
          })
const DenverSmartHomeInstallationRoute = DenverSmartHomeInstallationRouteImport.update({
            id: '/denver/smart-home-installation',path: '/denver/smart-home-installation',getParentRoute: () => rootRouteImport
          })
const EstimatorSavedRoute = EstimatorSavedRouteImport.update({
            id: '/estimator_/saved',path: '/estimator/saved',getParentRoute: () => rootRouteImport
          })
const HighlandsRanchHomeTheaterInstallationRoute = HighlandsRanchHomeTheaterInstallationRouteImport.update({
            id: '/highlands-ranch/home-theater-installation',path: '/highlands-ranch/home-theater-installation',getParentRoute: () => rootRouteImport
          })
const HighlandsRanchSmartHomeInstallationRoute = HighlandsRanchSmartHomeInstallationRouteImport.update({
            id: '/highlands-ranch/smart-home-installation',path: '/highlands-ranch/smart-home-installation',getParentRoute: () => rootRouteImport
          })
const ServiceAreasIndexRoute = ServiceAreasIndexRouteImport.update({
            id: '/service-areas/',path: '/service-areas/',getParentRoute: () => rootRouteImport
          })
const ServiceAreasSlugRoute = ServiceAreasSlugRouteImport.update({
            id: '/service-areas/$slug',path: '/service-areas/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesAvInstallationRoute = ServicesAvInstallationRouteImport.update({
            id: '/services/av-installation',path: '/services/av-installation',getParentRoute: () => rootRouteImport
          })
const ServicesClimateControlRoute = ServicesClimateControlRouteImport.update({
            id: '/services/climate-control',path: '/services/climate-control',getParentRoute: () => rootRouteImport
          })
const ServicesCommercialAvRoute = ServicesCommercialAvRouteImport.update({
            id: '/services/commercial-av',path: '/services/commercial-av',getParentRoute: () => rootRouteImport
          })
const ServicesConferenceRoute = ServicesConferenceRouteImport.update({
            id: '/services/conference',path: '/services/conference',getParentRoute: () => rootRouteImport
          })
const ServicesControl4Route = ServicesControl4RouteImport.update({
            id: '/services/control4',path: '/services/control4',getParentRoute: () => rootRouteImport
          })
const ServicesDolbyAtmosHomeTheaterRoute = ServicesDolbyAtmosHomeTheaterRouteImport.update({
            id: '/services/dolby-atmos-home-theater',path: '/services/dolby-atmos-home-theater',getParentRoute: () => rootRouteImport
          })
const ServicesHiddenAudioRoute = ServicesHiddenAudioRouteImport.update({
            id: '/services/hidden-audio',path: '/services/hidden-audio',getParentRoute: () => rootRouteImport
          })
const ServicesHomeTheaterRoute = ServicesHomeTheaterRouteImport.update({
            id: '/services/home-theater',path: '/services/home-theater',getParentRoute: () => rootRouteImport
          })
const ServicesLightingRoute = ServicesLightingRouteImport.update({
            id: '/services/lighting',path: '/services/lighting',getParentRoute: () => rootRouteImport
          })
const ServicesNetworkingRoute = ServicesNetworkingRouteImport.update({
            id: '/services/networking',path: '/services/networking',getParentRoute: () => rootRouteImport
          })
const ServicesOutdoorRoute = ServicesOutdoorRouteImport.update({
            id: '/services/outdoor',path: '/services/outdoor',getParentRoute: () => rootRouteImport
          })
const ServicesPrewireRoute = ServicesPrewireRouteImport.update({
            id: '/services/prewire',path: '/services/prewire',getParentRoute: () => rootRouteImport
          })
const ServicesRetrofitRoute = ServicesRetrofitRouteImport.update({
            id: '/services/retrofit',path: '/services/retrofit',getParentRoute: () => rootRouteImport
          })
const ServicesSecurityRoute = ServicesSecurityRouteImport.update({
            id: '/services/security',path: '/services/security',getParentRoute: () => rootRouteImport
          })
const ServicesShadingRoute = ServicesShadingRouteImport.update({
            id: '/services/shading',path: '/services/shading',getParentRoute: () => rootRouteImport
          })
const ServicesSmartHomeRoute = ServicesSmartHomeRouteImport.update({
            id: '/services/smart-home',path: '/services/smart-home',getParentRoute: () => rootRouteImport
          })
const ServicesTvMountingRoute = ServicesTvMountingRouteImport.update({
            id: '/services/tv-mounting',path: '/services/tv-mounting',getParentRoute: () => rootRouteImport
          })
const ServicesVoiceControlRoute = ServicesVoiceControlRouteImport.update({
            id: '/services/voice-control',path: '/services/voice-control',getParentRoute: () => rootRouteImport
          })
const ServicesWholeHomeAudioRoute = ServicesWholeHomeAudioRouteImport.update({
            id: '/services/whole-home-audio',path: '/services/whole-home-audio',getParentRoute: () => rootRouteImport
          })
const ServicesWholeHomeVideoRoute = ServicesWholeHomeVideoRouteImport.update({
            id: '/services/whole-home-video',path: '/services/whole-home-video',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsRoute
          })
const ToolsBankStatementsRoute = ToolsBankStatementsRouteImport.update({
            id: '/bank-statements',path: '/bank-statements',getParentRoute: () => ToolsRoute
          })
const ToolsBeforeAfterRoute = ToolsBeforeAfterRouteImport.update({
            id: '/before-after',path: '/before-after',getParentRoute: () => ToolsRoute
          })
const ToolsBrandsRoute = ToolsBrandsRouteImport.update({
            id: '/brands',path: '/brands',getParentRoute: () => ToolsRoute
          })
const ToolsBusinessCardsRoute = ToolsBusinessCardsRouteImport.update({
            id: '/business-cards',path: '/business-cards',getParentRoute: () => ToolsRoute
          })
const ToolsCableEstimatorRoute = ToolsCableEstimatorRouteImport.update({
            id: '/cable-estimator',path: '/cable-estimator',getParentRoute: () => ToolsRoute
          })
const ToolsChangeOrdersRoute = ToolsChangeOrdersRouteImport.update({
            id: '/change-orders',path: '/change-orders',getParentRoute: () => ToolsRoute
          })
const ToolsChecklistsRoute = ToolsChecklistsRouteImport.update({
            id: '/checklists',path: '/checklists',getParentRoute: () => ToolsRoute
          })
const ToolsClientsRoute = ToolsClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => ToolsRoute
          })
const ToolsContactsRoute = ToolsContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => ToolsRoute
          })
const ToolsEngineeringRoute = ToolsEngineeringRouteImport.update({
            id: '/engineering',path: '/engineering',getParentRoute: () => ToolsRoute
          })
const ToolsEstimatesRoute = ToolsEstimatesRouteImport.update({
            id: '/estimates',path: '/estimates',getParentRoute: () => ToolsRoute
          })
const ToolsExpensesRoute = ToolsExpensesRouteImport.update({
            id: '/expenses',path: '/expenses',getParentRoute: () => ToolsRoute
          })
const ToolsFollowUpsRoute = ToolsFollowUpsRouteImport.update({
            id: '/follow-ups',path: '/follow-ups',getParentRoute: () => ToolsRoute
          })
const ToolsGalleryRoute = ToolsGalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => ToolsRoute
          })
const ToolsLetterRoute = ToolsLetterRouteImport.update({
            id: '/letter',path: '/letter',getParentRoute: () => ToolsRoute
          })
const ToolsLoginRoute = ToolsLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => ToolsRoute
          })
const ToolsMaintenanceRoute = ToolsMaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => ToolsRoute
          })
const ToolsMarketingCopyRoute = ToolsMarketingCopyRouteImport.update({
            id: '/marketing-copy',path: '/marketing-copy',getParentRoute: () => ToolsRoute
          })
const ToolsPhotosRoute = ToolsPhotosRouteImport.update({
            id: '/photos',path: '/photos',getParentRoute: () => ToolsRoute
          })
const ToolsProductsRoute = ToolsProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => ToolsRoute
          })
const ToolsProjectsRoute = ToolsProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => ToolsRoute
          })
const ToolsProposalsRoute = ToolsProposalsRouteImport.update({
            id: '/proposals',path: '/proposals',getParentRoute: () => ToolsRoute
          })
const ToolsRackLayoutRoute = ToolsRackLayoutRouteImport.update({
            id: '/rack-layout',path: '/rack-layout',getParentRoute: () => ToolsRoute
          })
const ToolsReferralsRoute = ToolsReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => ToolsRoute
          })
const ToolsReviewsRoute = ToolsReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => ToolsRoute
          })
const ToolsSearchesRoute = ToolsSearchesRouteImport.update({
            id: '/searches',path: '/searches',getParentRoute: () => ToolsRoute
          })
const ToolsServiceTicketsRoute = ToolsServiceTicketsRouteImport.update({
            id: '/service-tickets',path: '/service-tickets',getParentRoute: () => ToolsRoute
          })
const ToolsSiteSurveysRoute = ToolsSiteSurveysRouteImport.update({
            id: '/site-surveys',path: '/site-surveys',getParentRoute: () => ToolsRoute
          })
const ToolsTestimonialsRoute = ToolsTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => ToolsRoute
          })
const ToolsTimesheetsRoute = ToolsTimesheetsRouteImport.update({
            id: '/timesheets',path: '/timesheets',getParentRoute: () => ToolsRoute
          })
const ToolsWarrantyRoute = ToolsWarrantyRouteImport.update({
            id: '/warranty',path: '/warranty',getParentRoute: () => ToolsRoute
          })
const EstimatorBlueprintIdRoute = EstimatorBlueprintIdRouteImport.update({
            id: '/estimator_/blueprint/$id',path: '/estimator/blueprint/$id',getParentRoute: () => rootRouteImport
          })
const ToolsBlogIndexRoute = ToolsBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => ToolsRoute
          })
const ToolsBlogIdRoute = ToolsBlogIdRouteImport.update({
            id: '/blog/$id',path: '/blog/$id',getParentRoute: () => ToolsRoute
          })
const ToolsBlogNewRoute = ToolsBlogNewRouteImport.update({
            id: '/blog/new',path: '/blog/new',getParentRoute: () => ToolsRoute
          })





const ToolsRouteChildren = {
  ToolsBankStatementsRoute: ToolsBankStatementsRoute,ToolsBeforeAfterRoute: ToolsBeforeAfterRoute,ToolsBrandsRoute: ToolsBrandsRoute,ToolsBusinessCardsRoute: ToolsBusinessCardsRoute,ToolsCableEstimatorRoute: ToolsCableEstimatorRoute,ToolsChangeOrdersRoute: ToolsChangeOrdersRoute,ToolsChecklistsRoute: ToolsChecklistsRoute,ToolsClientsRoute: ToolsClientsRoute,ToolsContactsRoute: ToolsContactsRoute,ToolsEngineeringRoute: ToolsEngineeringRoute,ToolsEstimatesRoute: ToolsEstimatesRoute,ToolsExpensesRoute: ToolsExpensesRoute,ToolsFollowUpsRoute: ToolsFollowUpsRoute,ToolsGalleryRoute: ToolsGalleryRoute,ToolsLetterRoute: ToolsLetterRoute,ToolsLoginRoute: ToolsLoginRoute,ToolsMaintenanceRoute: ToolsMaintenanceRoute,ToolsMarketingCopyRoute: ToolsMarketingCopyRoute,ToolsPhotosRoute: ToolsPhotosRoute,ToolsProductsRoute: ToolsProductsRoute,ToolsProjectsRoute: ToolsProjectsRoute,ToolsProposalsRoute: ToolsProposalsRoute,ToolsRackLayoutRoute: ToolsRackLayoutRoute,ToolsReferralsRoute: ToolsReferralsRoute,ToolsReviewsRoute: ToolsReviewsRoute,ToolsSearchesRoute: ToolsSearchesRoute,ToolsServiceTicketsRoute: ToolsServiceTicketsRoute,ToolsSiteSurveysRoute: ToolsSiteSurveysRoute,ToolsTestimonialsRoute: ToolsTestimonialsRoute,ToolsTimesheetsRoute: ToolsTimesheetsRoute,ToolsWarrantyRoute: ToolsWarrantyRoute,ToolsIndexRoute: ToolsIndexRoute,ToolsBlogIdRoute: ToolsBlogIdRoute,ToolsBlogNewRoute: ToolsBlogNewRoute,ToolsBlogIndexRoute: ToolsBlogIndexRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BlueprintCounterRoute: BlueprintCounterRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,EstimatorRoute: EstimatorRoute,GalleryRoute: GalleryRoute,HomeTheaterInstallationNearMeRoute: HomeTheaterInstallationNearMeRoute,HomeTheaterNearMeRoute: HomeTheaterNearMeRoute,InventoryRoute: InventoryRoute,PrivacyRoute: PrivacyRoute,SitemapRoute: SitemapRoute,SoldHomesRoute: SoldHomesRoute,SupportRoute: SupportRoute,ToolsRoute: ToolsRouteWithChildren,WholeHomeAudioInstallationNearMeRoute: WholeHomeAudioInstallationNearMeRoute,BlogSlugRoute: BlogSlugRoute,BlogCustomHomeTheaterDesignGuideRoute: BlogCustomHomeTheaterDesignGuideRoute,CastlePinesHomeTheaterInstallationRoute: CastlePinesHomeTheaterInstallationRoute,CastlePinesSmartHomeInstallationRoute: CastlePinesSmartHomeInstallationRoute,CastleRockHomeTheaterInstallationRoute: CastleRockHomeTheaterInstallationRoute,CastleRockSmartHomeInstallationRoute: CastleRockSmartHomeInstallationRoute,CherryCreekHomeTheaterInstallationRoute: CherryCreekHomeTheaterInstallationRoute,CherryCreekSmartHomeInstallationRoute: CherryCreekSmartHomeInstallationRoute,DenverSmartHomeInstallationRoute: DenverSmartHomeInstallationRoute,EstimatorSavedRoute: EstimatorSavedRoute,HighlandsRanchHomeTheaterInstallationRoute: HighlandsRanchHomeTheaterInstallationRoute,HighlandsRanchSmartHomeInstallationRoute: HighlandsRanchSmartHomeInstallationRoute,ServiceAreasSlugRoute: ServiceAreasSlugRoute,ServicesAvInstallationRoute: ServicesAvInstallationRoute,ServicesClimateControlRoute: ServicesClimateControlRoute,ServicesCommercialAvRoute: ServicesCommercialAvRoute,ServicesConferenceRoute: ServicesConferenceRoute,ServicesControl4Route: ServicesControl4Route,ServicesDolbyAtmosHomeTheaterRoute: ServicesDolbyAtmosHomeTheaterRoute,ServicesHiddenAudioRoute: ServicesHiddenAudioRoute,ServicesHomeTheaterRoute: ServicesHomeTheaterRoute,ServicesLightingRoute: ServicesLightingRoute,ServicesNetworkingRoute: ServicesNetworkingRoute,ServicesOutdoorRoute: ServicesOutdoorRoute,ServicesPrewireRoute: ServicesPrewireRoute,ServicesRetrofitRoute: ServicesRetrofitRoute,ServicesSecurityRoute: ServicesSecurityRoute,ServicesShadingRoute: ServicesShadingRoute,ServicesSmartHomeRoute: ServicesSmartHomeRoute,ServicesTvMountingRoute: ServicesTvMountingRoute,ServicesVoiceControlRoute: ServicesVoiceControlRoute,ServicesWholeHomeAudioRoute: ServicesWholeHomeAudioRoute,ServicesWholeHomeVideoRoute: ServicesWholeHomeVideoRoute,BlogIndexRoute: BlogIndexRoute,ServiceAreasIndexRoute: ServiceAreasIndexRoute,ServicesIndexRoute: ServicesIndexRoute,EstimatorBlueprintIdRoute: EstimatorBlueprintIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)